import React from "react";
import Markdown from "markdown-to-jsx";
import { Tooltip } from "@material-ui/core";
import { toast } from "react-toastify"; 

const elements = [
	"a",
	"abbr",
	"address",
	"area",
	"article",
	"aside",
	"audio",
	"b",
	"base",
	"bdi",
	"bdo",
	"big",
	"blockquote",
	"body",
	"br",
	"button",
	"canvas",
	"caption",
	"cite",
	"code",
	"col",
	"colgroup",
	"data",
	"datalist",
	"dd",
	"del",
	"details",
	"dfn",
	"dialog",
	"div",
	"dl",
	"dt",
	"em",
	"embed",
	"fieldset",
	"figcaption",
	"figure",
	"footer",
	"form",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hgroup",
	"hr",
	"html",
	"i",
	"iframe",
	"img",
	"input",
	"ins",
	"kbd",
	"keygen",
	"label",
	"legend",
	"li",
	"link",
	"main",
	"map",
	"mark",
	"marquee",
	"menu",
	"menuitem",
	"meta",
	"meter",
	"nav",
	"noscript",
	"object",
	"ol",
	"optgroup",
	"option",
	"output",
	"p",
	"param",
	"picture",
	"pre",
	"progress",
	"q",
	"rp",
	"rt",
	"ruby",
	"s",
	"samp",
	"script",
	"section",
	"select",
	"small",
	"source",
	"span",
	"strong",
	"style",
	"sub",
	"summary",
	"sup",
	"table",
	"tbody",
	"td",
	"textarea",
	"tfoot",
	"th",
	"thead",
	"time",
	"title",
	"tr",
	"track",
	"u",
	"ul",
	"var",
	"video",
	"wbr",

	// SVG
	"circle",
	"clipPath",
	"defs",
	"ellipse",
	"foreignObject",
	"g",
	"image",
	"line",
	"linearGradient",
	"marker",
	"mask",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"radialGradient",
	"rect",
	"stop",
	"svg",
	"text",
	"tspan",
];

const allowedElements = ["a", "b", "strong", "em", "u", "code", "del"];

const CustomLink = ({ children, ...props }) => (
	<a {...props} target="_blank" rel="noopener noreferrer">
		{children}
	</a>
);

const CopyableEmail = ({ children }) => {
  const email = children[0];

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation(); 
    navigator.clipboard.writeText(email);
    toast.success("Email copiado al portapapeles", { autoClose: 2000 });
  };

  return (
    <Tooltip title="Click para copiar" placement="top" arrow>
      <span
        onClick={handleCopy}
        style={{
          textDecoration: "underline",
          cursor: "pointer",
          color: "inherit",
          fontWeight: 500
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};

const MarkdownWrapper = ({ children }) => {
	const boldRegex = /\*(.*?)\*/g;
	const tildaRegex = /~(.*?)~/g;
	const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
	
	if (children && children.includes('BEGIN:VCARD')) {
		//children = "Diga olá ao seu novo contato clicando em *conversar*!";
		children = null;
	}
	
	if (children && children.includes('data:image/')) {
		children = null;
	}
	
	if (children) {
		children = children.replace(
			/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/g,
			"<email>$1</email>"
		);

		children = children.replace(
			/(<email>.*?<\/email>)|_/g,
			(match, emailGroup) => {
				if (emailGroup) return emailGroup;
				return "\\_";
			}
		);
	}
	
	if (children && emailRegex.test(children)) {
		children = children.replace(emailRegex, "<email>$1</email>");
	}

	if (children && boldRegex.test(children)) {
		children = children.replace(boldRegex, "**$1**");
	}
	if (children && tildaRegex.test(children)) {
		children = children.replace(tildaRegex, "~~$1~~");
	}
	
	if (children && boldRegex.test(children)) {
		children = children.replace(boldRegex, "**$1**");
	}
	if (children && tildaRegex.test(children)) {
		children = children.replace(tildaRegex, "~~$1~~");
	}

	const options = React.useMemo(() => {
		const markdownOptions = {
			disableParsingRawHTML: false,
			forceInline: true,
			overrides: {
				a: { component: CustomLink },
				email: { component: CopyableEmail },
				em: {
					component: ({ children }) => <>_{children}_</>
				}
			},
		};

		elements.forEach(element => {
			if (!allowedElements.includes(element)) {
				markdownOptions.overrides[element] = el => el.children || null;
			}
		});

		return markdownOptions;
	}, []);

	if (!children) return null;
	
	return <Markdown options={options}>{children}</Markdown>;
};

export default MarkdownWrapper;